import { i18n } from '../../i18n/translate';
import { appSwitcherMenu } from './cportal_user_navigation_menu';
import type { MenuEnvironment, MenuItem } from './types';

export const ceosNavigation = (environment: MenuEnvironment): MenuItem => {
  const { MENU_DOMAIN_FOR_ADMINIFI, MENU_DOMAIN_FOR_FRONT_END } = environment;

  return {
    id: 'foundry--universal_navigation--menus--ceos_navigation',
    type: 'menus',
    slug: 'foundry--universal_navigation--menus--ceos_navigation',
    title: '',
    icon: '',
    font_family: '',
    css_class: '',
    target_url: '',
    target_method: '',
    new_window: false,
    subsection: false,
    weight: 100,
    submenu_items: [
      {
        id: '',
        slug: '',
        title: i18n.t('Help'),
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        target_url: 'https://support.everfi.com/district-information',
        target_method: '',
        new_window: true,
        permissions: [{ has_rule_set: ['k12'] }],
        subsection: false,
        submenu_items: [],
        weight: 50,
      },
      {
        id: '',
        slug: '',
        title: i18n.t('Help'),
        icon: 'circle-question',
        font_family: '',
        css_class: '',
        target_url: 'https://help.everfi.com/K-12-impact-portal',
        target_method: '',
        new_window: true,
        permissions: [{ not_rule_set: ['k12'] }],
        subsection: false,
        submenu_items: [],
        weight: 50,
      },
      appSwitcherMenu(environment),
      {
        id: '',
        slug: '',
        title: '{{user_name}}',
        icon: 'circle-user',
        font_family: '',
        css_class: 'account',
        target_url: '',
        target_method: '',
        new_window: false,
        subsection: false,
        submenu_items: [
          {
            id: 'my_profile',
            slug: '',
            title: i18n.t('My Profile'),
            icon: '',
            font_family: '',
            css_class: '',
            module: 'adminifi',
            target_url: `${MENU_DOMAIN_FOR_FRONT_END}/{{slug}}/{{context}}/registrations/edit`,
            target_method: '',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'logout',
            slug: 'logout',
            title: i18n.t('Logout'),
            icon: '',
            font_family: '',
            css_class: '',
            module: 'adminifi',
            target_url: `${MENU_DOMAIN_FOR_ADMINIFI}/{{slug}}/sign_out`,
            target_method: 'GET',
            new_window: false,
            subsection: false,
            submenu_items: [],
            weight: 100,
          },
          {
            id: '',
            slug: '',
            title: '',
            icon: '',
            font_family: '',
            css_class: '',
            target_url: '',
            target_method: '',
            new_window: false,
            subsection: true,
            weight: 99,
            submenu_items: [
              {
                id: '',
                slug: '',
                title: i18n.t('Privacy Policy'),
                icon: 'file-shield',
                font_family: '',
                css_class: '',
                data_attribute: 'privacy-policy-link',
                privacy_processing: 'policy',
                target_url: '',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Privacy Choices'),
                icon: 'ballot-check',
                font_family: '',
                css_class: '',
                data_attribute: 'privacy-choices-link',
                privacy_processing: 'choices',
                target_url: '',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
              {
                id: '',
                slug: '',
                title: i18n.t('Terms of Service'),
                icon: 'shield-check',
                font_family: '',
                css_class: '',
                target_url: 'https://everfi.com/terms-of-service',
                target_method: '',
                new_window: true,
                subsection: false,
                submenu_items: [],
                weight: 100,
              },
            ],
          },
        ],
      },
    ],
  };
};
